// ReSharper disable once InconsistentNaming
export const CONFIRM_TYPE_DANGER : string = 'danger';
export const CONFIRM_TYPE_ASK : string = 'ask';
export const CONFIRM_TYPE_INFO : string = 'info';
